import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import { Location } from '@reach/router'
import _ from 'lodash'

import StoreImagelinks from '../components/storeimages'
import '../../static/css/footer.css'

const footer_msg = {
  en: (
    <strong>
      Smart is simple. Stay on track with your effortless spending-tracker.
    </strong>
  ),
  zh: <strong>立即下載 gini，引領智能理財文化！</strong>,
}

const MENU = {
  en: [
    { to: '/our-story', text: 'About' },
    { to: 'https://blog.gini.co/blog', text: 'Blog', extern: true },
    // { to: '/contact-us', text: "Contact" },
    { to: '/privacy-policy', text: 'Privacy' },
    { to: '/user-terms', text: 'Terms' },
  ],
}

const Footnav = props => {
  // hardcode: only support en for now
  const lang = props.lang ? props.lang : 'en'
  const nav_items = _.map(MENU[lang], (item, idx) => {
    if (item.extern != null) {
      return (
        <a href={item.to} key={idx}>
          {item.text}
        </a>
      )
    } else if (item.to != null) {
      return (
        <Link to={item.to} key={idx}>
          {item.text}
        </Link>
      )
    }
  })
  return <div className="footer__nav">{nav_items}</div>
}

const Social = () => (
  <div
    className="footer__contact"
    style={{
      width: '100%',
      textAlign: 'center',
    }}
  >
    <a href="https://www.linkedin.com/company/gini.co/?originalSubdomain=hk">
      <img src="/img/shared/linkedinfinal-01.svg" alt="LinkedIn" />
    </a>
    <a href="https://www.facebook.com/giniHK/">
      <img src="/img/shared/facebookfinal-01.svg" alt="Facebook" />
    </a>
    <a href="https://www.instagram.com/gini.co/?hl=en">
      <img src="/img/shared/instagramfinal-01.svg" alt="Instagram" />
    </a>
  </div>
)

const Footer = () => (
  <>
    <div className="get-in-touch-section">
      <div className="get-in-touch-section__inner">
        <div
          className="get-in-touch-section__title"
          style={{ paddingBottom: '20px' }}
        >
          <StaticQuery
            query={graphql`
              {
                site {
                  siteMetadata {
                    lang
                  }
                }
              }
            `}
            render={data => footer_msg[data.site.siteMetadata.lang]}
          />
        </div>
        <Location>
          {lprops => {
            const APPLINKS = {
              index: {
                ios: 'https://1377.app.link/QAi1KmdwwS',
                goog: 'https://1377.app.link/Wd6lx0ERWT',
              },
              security: {
                ios: 'https://1377.app.link/Mzwd4CaSWT',
                goog: 'https://1377.app.link/wPPVXu4RWT',
              },
              howitworks: {
                ios: 'https://1377.app.link/DB8CsIUcLT',
                goog: 'https://1377.app.link/y5SI4xQRWT',
              },
            }

            const path = lprops.location.pathname
              .split('/')
              .filter(s => s !== '')
            const route = path[path.length - 1].replace(/-/g, '')
            let ios, goog

            if (route in APPLINKS) {
              ios = APPLINKS[route].ios
              goog = APPLINKS[route].goog
            } else {
              ios = APPLINKS.index.ios
              goog = APPLINKS.index.goog
            }
            return <StoreImagelinks ios_link={ios} goog_link={goog} />
          }}
        </Location>
      </div>
    </div>

    <footer className="footer">
      <div className="footer__inner">
        <Social />
        <Footnav />
        <div className="footer__copyright">
          <p>Copyright © {new Date().getFullYear()} More Champ Limited</p>
        </div>
      </div>
    </footer>

    <script type="text/javascript" src="/js/analytics.js" />
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=1726785784291394&ev=PageView&noscript=1"
        alt="fb-root"
      />
    </noscript>
  </>
)

export default Footer
